/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryMutationHook} from '../types'
import {firePlaidSandboxItemWebhook} from '../api'

export const useMutationFirePlaidSandboxItemWebhook = createReactQueryMutationHook('firePlaidSandboxItemWebhook', firePlaidSandboxItemWebhook)
